import * as React from 'react'
import { Box } from '@mui/material'
import { WeightedSkillsLists } from '../WeightedSkillsLists'
import { ExportToGoogleSheet } from './ExportToGoogleSheet'
import { ImportStandardsFromSheet } from './ImportStandardsFromSheet'
import { CascadeStandards } from './CascadeStandards'
import { SyncTree } from './SyncTree'

interface SyncStandardsProps {
  treeId: string
  versionId: string
}

export function SyncStandards({ treeId, versionId }: SyncStandardsProps) {
  return (
    <Box>
      <WeightedSkillsLists treeId={treeId} treeVer={versionId} />
      <ExportToGoogleSheet treeId={treeId} versionId={versionId} />
      <ImportStandardsFromSheet treeId={treeId} versionId={versionId} />
      <CascadeStandards treeId={treeId} versionId={versionId} />
      <SyncTree treeId={treeId} versionId={versionId} />
    </Box>
  )
}
